import { workOrders } from "./workOrders/workOrdersReducer";
import { loggedEmployee } from "./employees/loggedEmployeeReducer";
import { componentsPark } from "./componentsPark/componentsParkReducer";
import { searchHistory } from "./searchHistory/searchHistoryReducer";
import { extranetInterventions, extranetIntervention } from './intervention/extranetInterventionReducer';
import { sites } from './customerSite/customerSiteReducer'
import { news } from './news/newsReducer';
import { invoices } from './invoices/invoicesReducer';
import { affair, affairs } from './affair/affairReducer';
import { quotes } from './quote/quoteReducer';
import { companies } from './companies/extranetCompaniesReducer';
import { homeWidgets } from './home/homeWidgetReducer';
import { changePassword } from './users/usersReducer';

export default {
    loggedEmployee,

    workOrders,

    extranetInterventions,
    extranetIntervention,

    componentsPark,

    searchHistory,

    news,

    homeWidgets,

    sites,

    invoices,

    affair,
    affairs,

    quotes,

    companies,

    changePassword,
};
